<app-mobile-button-bar></app-mobile-button-bar>

<div class="row">
  <div class="col col-md-8">
    <app-dotazniky></app-dotazniky>
    <section class="d-block d-md-none">
      <app-podpora></app-podpora>
    </section>
    <app-poplatky></app-poplatky>
    <app-messages></app-messages>
    <app-job-market></app-job-market>
    <app-rozvrh></app-rozvrh>
</div>
</div>
<div class="row">
  <div class="col col-md-8">
    <app-studium></app-studium>
  </div>
</div>
